import { render, staticRenderFns } from "./PhanQuyen.vue?vue&type=template&id=d6b1eca4&scoped=true"
import script from "./PhanQuyen.vue?vue&type=script&lang=js"
export * from "./PhanQuyen.vue?vue&type=script&lang=js"
import style0 from "./PhanQuyen.vue?vue&type=style&index=0&id=d6b1eca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b1eca4",
  null
  
)

export default component.exports